import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools';

import { preloadCreateIntroFirstStepOnboardingState } from './preloadCreateIntroFirstStepOnboardingState';
import { preloadGetPersonalSpaceKeyQuery } from './preloadGetPersonalSpaceKeyQuery';
import { preloadGetTemplateInfoQuery } from './preloadGetTemplateInfoQuery';
import { preloadUserPersonalizationQuery } from './preloadUserPersonalizationQuery';

export const preloadCreateIntroFirstStep = () => {
	return waitForAllReturnWhenError([
		preloadGetPersonalSpaceKeyQuery(),
		preloadGetTemplateInfoQuery(),
		preloadUserPersonalizationQuery(),
		preloadCreateIntroFirstStepOnboardingState(),
	]);
};
